var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuranBackdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 160,
    viewBox: "0 0 269 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M162.056 198C239.288 198 301.896 183.434 301.896 165.467C301.896 147.5 239.288 132.934 162.056 132.934C84.8235 132.934 22.2146 147.5 22.2146 165.467C22.2146 183.434 84.8235 198 162.056 198Z",
    fill: "#042830"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.574 8.46497L162.056 45.8834L52.4265 8.46497L0 84.6343L162.056 140.04L324 84.6343L271.574 8.46497Z",
    fill: "#297199"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M19.1046 81.5253L153.503 132.934L107.297 87.1881C107.297 87.1881 31.4337 68.8675 19.1046 81.5253Z",
    fill: "#0F4B4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M305.007 81.5253L170.608 132.934L216.815 87.1881C216.703 87.1881 292.566 68.8675 305.007 81.5253Z",
    fill: "#0F4B4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.056 140.04L0 84.6343V91.8515L162.056 147.257L324 91.8515V84.6343L162.056 140.04Z",
    fill: "#3DB9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7518 173.35L94.5232 124.162L154.947 144.815L75.7518 173.35Z",
    fill: "#1D6578"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M80.9723 159.138L154.947 144.815L94.5232 124.162L80.9723 159.138Z",
    fill: "#1D6578"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M162.056 142.261L75.7518 173.351L82.1941 180.124L162.056 151.699L241.806 180.124L248.359 173.351L162.056 142.261Z",
    fill: "#3DB9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.359 173.35L229.477 124.162L169.053 144.815L248.359 173.35Z",
    fill: "#1D6578"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M243.028 159.138L169.053 144.815L229.477 124.162L243.028 159.138Z",
    fill: "#1D6578"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.055 151.699C165.307 151.699 167.942 149.064 167.942 145.814C167.942 142.564 165.307 139.929 162.055 139.929C158.804 139.929 156.169 142.564 156.169 145.814C156.169 149.064 158.804 151.699 162.055 151.699Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M266.909 8.46497L162.056 60.651L57.2026 8.46497C52.4265 14.7939 13.9952 78.8605 13.9952 78.8605C14.4395 78.8605 14.7728 78.9716 15.217 78.9716C111.628 88.6315 138.397 118.944 147.283 126.272C156.169 133.711 162.167 132.934 162.167 132.934C162.167 132.934 168.165 133.711 177.05 126.272C185.936 118.944 212.705 88.6315 309.116 78.9716C309.561 78.9716 309.894 78.8605 310.338 78.8605C310.116 78.8605 271.574 14.9049 266.909 8.46497Z",
    fill: "#04F5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M310.116 78.8605C309.672 78.8605 309.338 78.9716 308.894 78.9716C212.483 88.6315 185.714 118.944 176.828 126.272C167.942 133.711 161.944 132.934 161.944 132.934C161.944 132.934 155.947 133.711 147.061 126.272C138.175 118.944 111.406 88.6315 14.9949 78.9716C14.5506 78.9716 14.2173 78.8605 13.7731 78.8605C12.9955 80.0819 13.7731 80.9702 13.7731 80.9702C111.184 90.4081 137.064 120.831 145.95 128.271C154.836 135.599 161.833 135.044 161.833 135.044C161.833 135.044 168.831 135.599 177.717 128.271C186.603 120.942 212.483 90.5191 309.894 80.9702C310.116 80.9702 310.893 80.0819 310.116 78.8605Z",
    fill: "#3DB9D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M262.91 2.35811C209.262 -10.5218 161.944 33.5587 161.944 33.5587C161.944 33.5587 114.627 -10.5218 60.9791 2.35811C60.9791 2.35811 45.7621 25.6752 24.7693 65.3144C24.7693 65.3144 130.4 77.195 161.944 121.498C193.489 77.195 299.12 65.3144 299.12 65.3144C278.127 25.6752 262.91 2.35811 262.91 2.35811Z",
    fill: "#EFFBFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M299.12 65.3144C299.12 65.3144 193.489 77.195 161.944 121.498C130.511 77.195 24.8803 65.3144 24.8803 65.3144C24.8803 65.3144 24.8803 68.8675 18.9934 75.8626C18.9934 75.8626 114.849 82.7467 149.726 122.497C157.946 131.824 161.944 130.713 161.944 130.713C161.944 130.713 166.054 131.824 174.162 122.497C208.928 82.7467 304.895 75.8626 304.895 75.8626C299.12 68.7564 299.12 65.3144 299.12 65.3144Z",
    fill: "#CBEDF4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.912 7.02156C256.912 7.02156 216.815 -3.19358 161.944 39.3324C107.185 -3.08255 66.9771 7.02156 66.9771 7.02156L39.8752 59.6517C122.291 65.3144 161.944 106.952 161.944 106.952C161.944 106.952 201.598 65.3144 284.014 59.6517L256.912 7.02156ZM162.056 101.956C162.056 101.956 124.957 63.982 46.3175 56.5427L69.0875 9.24224C69.0875 9.24224 108.518 1.58089 162.056 41.7752C215.593 1.58089 255.024 9.24224 255.024 9.24224L277.794 56.5427C199.154 63.982 162.056 101.956 162.056 101.956Z",
    fill: "#3EB1D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.163 78.9647C186.973 68.0464 233.253 43.8848 264.354 47.2159",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.163 48.3262C185.307 38.0385 219.48 17.8815 251.025 19.5555",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.163 63.871C186.418 52.7919 223.479 31.0844 257.689 32.8871",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.281 78.9647C138.471 68.0464 92.1906 43.8848 61.0901 47.2159",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.281 48.3262C140.137 38.0385 105.964 17.8815 74.4189 19.5555",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.281 63.871C139.026 52.7919 101.965 31.0844 67.7545 32.8871",
    stroke: "#3DB9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuranBackdrop);
export default __webpack_public_path__ + "static/media/quranBackdrop.0ecf56e7cd8b1226e2fef69e07a7a195.svg";
export { ForwardRef as ReactComponent };